<template>
	<div data-tour-scope="affiliate-marketing">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation="0">
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title>Affiliate Marketing</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
							<v-spacer></v-spacer>
							<v-toolbar-items>
								<!-- una sola azione: il piu' porta dritto alla pagina, senza menu -->
								<v-btn text title="Nuovo banner" data-tour="add" @click="createItem">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
							</v-toolbar-items>
						</v-toolbar>

						<v-col cols="12">
							<v-row data-tour="filters">
								<v-col cols="12" md="6">
									<v-text-field v-model="searchfield" label="Cerca" outlined append-icon="mdi-magnify" dense @click:append="getSearch()" @keyup.enter="getSearch()" hide-details />
								</v-col>
								<v-col cols="12" md="6">
									<v-select v-model="settings.filters.lang" :items="languages" item-text="lang" item-value="lang" label="Lingua" dense clearable outlined hide-details />
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" class="pt-0" data-tour="newsletter">
							<div class="d-flex align-center flex-wrap">
								<span class="mr-3">Copia link testuale per newsletter</span>
								<v-btn class="banner-copy-btn" color="primary" dark small @click="copyNewsletterLink">
									<v-icon left>mdi-content-copy</v-icon>
									Copia
								</v-btn>
							</div>
						</v-col>

						<v-data-table data-tour="table" :hide-default-header="mobileCards" :class="{ 'table-cards': mobileCards }" :headers="headers" :items="getItems" :options.sync="settings.options" :server-items-length="total" must-sort class="elevation-0" :footer-props="{ 'items-per-page-options': listSize }">
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="affiliate-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="item.name" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon v-bind="attrs" v-on="on" color="primary" small data-tour="row-menu">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link data-tour="row-primary" @click="editItem(item)">
																<v-list-item-title class="size9">Modifica</v-list-item-title>
															</v-list-item>
															<v-list-item link @click="deleteItem(item)">
																<v-list-item-title class="size9">Elimina</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<!-- anteprima del banner: scorre in orizzontale se piu' larga del telefono -->
												<div v-if="getBannerIframeUrl(item)" class="banner-preview mb-2">
													<iframe
														:src="getBannerIframeUrl(item)"
														:width="item.width"
														:height="item.height"
														frameborder="0"
														scrolling="no"
														style="border: 0; overflow: hidden; display: block"
													></iframe>
												</div>
												<v-btn class="banner-copy-btn" color="primary" dark small block @click="copyToClipboard(item)">
													<v-icon left>mdi-content-copy</v-icon>
													Copia codice
												</v-btn>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="item in items" :key="item._id">
										<td class="pl-0 pr-0" style="width: 5px">
											<v-menu top eager>
												<template v-slot:activator="{ on, attrs }">
											<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense data-tour="row-menu">
														<v-icon dark>mdi-dots-vertical</v-icon>
													</v-btn>
												</template>
												<v-list>
											<v-list-item link data-tour="row-primary" @click="editItem(item)">
														<v-list-item-title class="size9">Modifica</v-list-item-title>
													</v-list-item>
													<v-list-item link @click="deleteItem(item)">
														<v-list-item-title class="size9">Elimina</v-list-item-title>
													</v-list-item>
												</v-list>
											</v-menu>
										</td>
										<td>{{ item.created_at | moment('DD/MM/YYYY') }}</td>
										<td>{{ item.name }}</td>
										<td>{{ item.width }}</td>
										<td>{{ item.height }}</td>
										<td>{{ item.lang }}</td>
										<td>
											<div class="pt-2 pb-2">
												<iframe
													v-if="getBannerIframeUrl(item)"
													:src="getBannerIframeUrl(item)"
													:width="item.width"
													:height="item.height"
													frameborder="0"
													scrolling="no"
													style="border: 0; overflow: hidden; display: block"
												></iframe>
											</div>
										</td>
										<td>
											<v-btn class="banner-copy-btn" color="primary" dark small @click="copyToClipboard(item)">
												<v-icon left>mdi-content-copy</v-icon>
												Copia
											</v-btn>
										</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Eliminando il banner non potrai più ripristinarlo.</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>
					<v-btn color="primary" text @click="confirmDelete"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
			<span v-html="snackbar.text"></span>
			<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
		</v-snackbar>
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createMarketingTourSteps, stopAffiliateListTour } from './affiliate-list-tours';
import { listRouteState } from '@/components/core/list/listRouteState';

const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'AffiliateMarketing',
	components: {
		TourOverlay,
		KeyValueCard,
	},
	// pagina, righe, ordinamento, ricerca e lingua stanno nell'URL: refresh e ritorno dalle schede ripartono da li'
	mixins: [listRouteState({ filters: { lang: 'string' }, perPageOptions: LIST_SIZE })],
	setup() {
		return { tour: useTour(createMarketingTourSteps(), { onStop: () => stopAffiliateListTour('affiliate-marketing') }) };
	},
	data() {
		return {
			total: 0,
			dialogconfirm: false,
			selectedDeleteItem: null,
			listSize: LIST_SIZE,
			searchfield: '',
			languages: [],
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {
					lang: '',
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			}),
			headers: [
				{ text: '', value: 'actions', sortable: false },
				{ text: 'Created', value: 'created_at', sortable: true },
				{ text: 'Nome', value: 'name', sortable: true },
				{ text: 'Width', value: 'width', sortable: true },
				{ text: 'Height', value: 'height', sortable: true },
				{ text: 'Lingua', value: 'lang', sortable: true },
				{ text: 'Immagine', value: 'image', sortable: false },
				{ text: '', value: 'copy', sortable: false },
			],
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
		};
	},
	computed: {
		...mapGetters({
			getItems: 'banners/getItems',
			getSettings: 'settings/getSetting',
		}),
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
	},
	async created() {
		await this.fetchSetting();
		this.languages = _.orderBy(_.filter(this.getSettings.languages, { is_active: true }), ['default'], ['desc']);
		await this.listLoad();
	},
	methods: {
		...mapActions({
			fetchItems: 'banners/asyncFetchData',
			fetchSetting: 'settings/asyncFetchData',
			deleteBanner: 'banners/deleteItem',
		}),
		async getDataFromApi() {
			const result = await this.fetchItems(this.settings);
			if (result) {
				this.total = result.total;
			}
		},
		// ricerca da tre caratteri; il caricamento lo fa listRouteState
		getSearch() {
			this.settings.search = _.size(this.searchfield) >= 3 ? this.searchfield : '';
		},
		createItem() {
			this.$router.push('/affiliate/marketing/new');
		},
		editItem(item) {
			if (!item?._id) {
				return;
			}
			this.$router.push(`/affiliate/marketing/${item._id}`);
		},
		deleteItem(item) {
			if (!item?._id) {
				return;
			}

			this.selectedDeleteItem = item;
			this.dialogconfirm = true;
		},
		async confirmDelete() {
			if (!this.selectedDeleteItem?._id) {
				this.dialogconfirm = false;
				return;
			}

			try {
				await this.deleteBanner({ _id: this.selectedDeleteItem._id });
				await this.getDataFromApi();
				this.dialogconfirm = false;
				this.selectedDeleteItem = null;
				this.snackbar.color = 'success';
				this.snackbar.text = 'Banner eliminato con successo';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 4000;
			} catch (e) {
				this.snackbar.color = 'error';
				this.snackbar.text = "Errore durante l'eliminazione del banner";
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 4000;
			}
		},
		// campi in sola lettura della card da telefono
		campiCard(item) {
			return [
				{ label: 'Creato', value: item.created_at ? this.$moment(item.created_at).format('DD/MM/YYYY') : '' },
				{ label: 'Dimensioni', value: item.width || item.height ? `${item.width || '-'} x ${item.height || '-'}` : '' },
				{ label: 'Lingua', value: item.lang },
			];
		},
		getBannerIframeUrl(item) {
			let baseUrl = (this.getSettings?.website || '').trim();
			const profileId = this.getSettings?._id || '';
			if (!baseUrl || !item?._id) {
				return '';
			}

			if (!/^https?:\/\//i.test(baseUrl)) {
				baseUrl = `https://${baseUrl}`;
			}

			baseUrl = baseUrl.replace(/\/$/, '');

			const url = new URL(`${baseUrl}/banner`);
			url.searchParams.set('banner', item._id);
			if (profileId) {
				url.searchParams.set('partner', profileId);
			}
			return url.toString();
		},
		getBannerIframeCode(item) {
			const src = this.getBannerIframeUrl(item);
			if (!src) {
				return '';
			}

			return `<iframe src="${src}" width="${item.width}" height="${item.height}" frameborder="0" scrolling="no" style="border:0;overflow:hidden;display:block;"></iframe>`;
		},
		getNewsletterUrl() {
			let baseUrl = (this.getSettings?.website || '').trim();
			const profileId = this.getSettings?._id || '';

			if (!baseUrl || !profileId) {
				return '';
			}

			if (!/^https?:\/\//i.test(baseUrl)) {
				baseUrl = `https://${baseUrl}`;
			}

			const url = new URL(baseUrl.replace(/\/$/, ''));
			url.searchParams.set('affiliate', profileId);
			return url.toString();
		},
		async copyText(value, successText, errorText) {
			if (!value) {
				return;
			}

			try {
				if (navigator.clipboard && navigator.clipboard.writeText) {
					await navigator.clipboard.writeText(value);
				} else {
					const textarea = document.createElement('textarea');
					textarea.value = value;
					textarea.setAttribute('readonly', '');
					textarea.style.position = 'absolute';
					textarea.style.left = '-9999px';
					document.body.appendChild(textarea);
					textarea.select();
					document.execCommand('copy');
					document.body.removeChild(textarea);
				}

				this.snackbar.color = 'success';
				this.snackbar.text = successText;
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 3000;
			} catch (e) {
				this.snackbar.color = 'error';
				this.snackbar.text = errorText;
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 4000;
			}
		},
		async copyNewsletterLink() {
			await this.copyText(this.getNewsletterUrl(), 'Link newsletter copiato', 'Errore durante la copia del link newsletter');
		},
		async copyToClipboard(item) {
			const code = this.getBannerIframeCode(item);
			await this.copyText(code, 'Codice iframe copiato', 'Errore durante la copia del codice iframe');
		},
	},
	beforeDestroy() {
		this.tour.stop();
		this.$store.dispatch('banners/destroyData');
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.affiliate-cards,
.affiliate-cards tr {
	display: block;
	width: 100%;
}
.affiliate-cards tr,
.affiliate-cards tr:hover {
	background: transparent !important;
}
.affiliate-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.affiliate-cards tr:first-child td {
	padding-top: 12px !important;
}
.affiliate-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.affiliate-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
.banner-preview {
	max-width: 100%;
	overflow-x: auto;
}
</style>
